import React, { useState } from "react";
import AdminNavbar from "../components/AdminSideComponents/layout/admin/AdminNavbar";
import AdminSidebar from "../components/AdminSideComponents/layout/admin/AdminSidebar";
import { ADMIN_NAV_HEIGHT } from "../utils/constants";

const AdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <React.Fragment>
      <div className="relative h-screen w-full overflow-hidden">
        {/* SIDEBAR */}
        <AdminSidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

        {/* CONTENT AREA */}
        <div className="flex flex-col h-screen lg:ml-[14.5rem]">
          {/* NAVBAR */}
          <div className="fixed top-0 left-0 right-0 lg:ml-[14.5rem] z-20">
            <AdminNavbar setIsSidebarOpen={setIsSidebarOpen} />
          </div>

          {/* SCROLLABLE MAIN */}
          <main
            style={{
              scrollbarGutter: "stable",
              marginTop: `${ADMIN_NAV_HEIGHT}px`,
            }}
            className="flex-1 overflow-y-auto bg-gray-100"
          >
            {children}
          </main>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdminLayout;
